import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

import EgresoIngresoModoConstant from 'constants/egresoIngresoModo'

const TipoFormGroup = ({ fIsSubmitting, values }) => {
  return (
    <Row>
      <Col md={3} />
      {/* <Col md={3} className='pt-2'>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Radio
              {...field}
              disabled={fIsSubmitting}
              checked={values.tipo === EgresoIngresoModoConstant.INGRESO}
              id='radio-INGRESO'
              label={EgresoIngresoModoConstant.__dictionary[EgresoIngresoModoConstant.INGRESO].nombre}
              value={EgresoIngresoModoConstant.__dictionary[EgresoIngresoModoConstant.INGRESO].id}
            />
          )}
        </Field>
      </Col> */}
      <Col md={3} className='pt-2'>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Radio
              {...field}
              disabled={fIsSubmitting}
              checked={values.tipo === EgresoIngresoModoConstant.EGRESO}
              id='radio-flagEGRESO'
              label={EgresoIngresoModoConstant.__dictionary[EgresoIngresoModoConstant.EGRESO].nombre}
              value={EgresoIngresoModoConstant.__dictionary[EgresoIngresoModoConstant.EGRESO].id}
            />
          )}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(TipoFormGroup)
